import "./sheet.css";

import { SheetBack } from "./sheet-back";
import type { SheetData } from "./sheet-data";
import { SheetFront } from "./sheet-front";

/**
 * Both sheet pages in the wrapper the print rules target.
 *
 * One component rather than the same three lines in the route and the preview
 * harness. The duplicate cost two extra printed pages once already: the copy in
 * the preview was missing `kit-sheet-stack`, so the on-screen padding and gap
 * survived into print and pushed each 297mm page onto a second sheet. There is
 * nothing left to keep in step now.
 */
export function SheetStack({ sheet }: { sheet: SheetData }) {
  return (
    <div className="kit-sheet-stack bg-surface-strong flex flex-col items-center gap-[8mm] p-[8mm]">
      <SheetFront sheet={sheet} />
      <SheetBack sheet={sheet} />
    </div>
  );
}
